// removed by extract-text-webpack-plugin
module.exports = {"base":"src-components-Welcome----Welcome-module---base---aOYj-","content":"src-components-Welcome----Welcome-module---content---3tk00","checkBoxes":"src-components-Welcome----Welcome-module---checkBoxes---1ljBv","slidein":"src-components-Welcome----Welcome-module---slidein---1L36V","i":"src-components-Welcome----Welcome-module---i---2R24W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Welcome/Welcome.module.scss
// module id = 254
// module chunks = 213534597649335